<!--suppress AngularUndefinedBinding -->
<div (pmClickedOutside)="this.deactivate()" [clickedOutsideActive]="isActive">
  <div class="process" [style.width]="width + 'px'" [style.min-height]="height + 'px'" [ngClass]="shape"
    [class.active]="isActive" [class.editText]="isEditingText" [class.highlight]="context?.highlights?.text"
    [class.expandable]="hasArrow" [class.pm-no-select]="!isEditingText" #processWrapper
    (contextmenu)="contextMenu($event)"
    (click)="processClicked($event)"
    (pm-dragEnter)="onMouseEnter()" (touchstart)="onMouseEnter()" (mouseleave)="onMouseLeave()"
    (touchend)="onMouseLeave()" (pm-resize)="onResizeMove($event.detail)"
    (pm-resizeend)="onResizeEnd()" [attr.data-element-type]="context.nodeType"
    [attr.data-element-template-id]="context.templateId" [attr.data-element-template-version]="context.templateVersion" [attr.data-element-id]="context.id"
    [matTooltip]="getOwner(isTouching$ | async)" [matTooltipShowDelay]="500">
    <pm-shape [style]="context.style" [isOpen]="context.isOpen && context.nodeType !== 'page' && !isActive" [width]="width" [height]="measuredHeight" [highlight]="context?.highlights?.text"></pm-shape>
    <div class="process-wrapper" [ngClass]="shapePaddingClass">
      @if(showIconArea) {
        <div class="new-style-area" [class.contrast-dark]="isDark(context?.style?.bgColor)" >
          @if(context.icon) {
            <mat-icon class="pm-user-icon material-symbols-large">{{context.icon}}</mat-icon>
          }
          @let arrowIcon = arrowIconName(context?.style?.shape);
          @if(arrowIcon) {
            <div class="pm-arrow-overlay" [class.with-icon]="context?.icon" >
              <mat-icon [class.contrast-dark]="isDark(context?.style?.bgColor)" class="pm-arrow-icon material-symbols-unfilled">{{arrowIcon}}</mat-icon>
            </div>
          }
        </div>
      }
      <div class="pm-user-content-centerer">
        <div class="pm-user-content" [class.isOpen]="context.isOpen && context.nodeType !== 'page' && !isActive" [pmTrumbowyg]="trumbowygOptions" (textUpdate)="textUpdate()" (pmLinkClick)="linkClicked($event)"
             [enabled]="isEditingText" [offsetElement]="processWrapper" [innerHtml]="context.label | unsafeHtml"></div>
      </div>
    </div>
    @if (hasArrow && !isActive) {
      <mat-icon class="pm-open-icon pm-remove-when-dragging" aria-label="open process">arrow_drop_down
      </mat-icon>
    }
    <!-- TODO: Replace icon -->
    @if (isActive && context.writeable && isAuthor) {
      <mat-icon svgIcon="proman-resize-handle" class="pm-resize-handle pm-remove-when-dragging"></mat-icon>
    }
    <pm-menu-trigger-overlay (click)="toggleMenu($event)"></pm-menu-trigger-overlay>
  </div>
  @if (isActive && context.autoTranslated.text) {
    <div class="mat-small pm-auto-translate-notice">{{'menu.link.auto-translated' | translate}}</div>
  }
  @if (context.nodeType != 'page') {
    <div [class.pm-dropzone-under]="dragDropActive && context.writeable" [class.pm-dropzone-dead]="!dragDropActive" [attr.data-element-id]="context.id" data-element-drop-type="under"
      [attr.data-element-type]="context.nodeType">
      <div class="pm-dropzone-highlight"></div>
    </div>
  }
  @if (isActive) {
    <pm-options-overlay [context]="context"  [contextElement]="processDiv"
    (toggleEdit)="toggleEdit($event)"></pm-options-overlay>
  }

  <div class="overlays">
    <pm-labels-overlay [context]="context"></pm-labels-overlay>
    @if (hasLinks()) {
      <pm-link-overlay [node]="context" (linkClicked)="linkClicked($event)"
        [highlightInfo]="context?.highlights?.info" (contextmenu)="toggleMenu($event)"
      ></pm-link-overlay>
    }
  </div>

  @if (hasLinks()) {
    <pm-link-menu [node]="context" [open]="isActive && !isEditingText" [isAuthor]="isAuthor"
    (linkClicked)="linkClicked($event)"></pm-link-menu>
  }
  @if (context.nodeType != 'page') {
    <pm-bullet-list class="bullet-wrapper" [isAuthor]="isAuthor" [isTemplateRoot]="isTemplateRoot"
      [bullets]="context.bullets" [dragDropActive]="dragDropActive && context.writeable"
      (activationChange)="activationChange.emit($event)" (elementClick)="elementClick.emit($event)"
      (linkClick)="linkClick.emit($event)" (resized)="resized.emit($event)" (updated)="updated.emit($event)">
    </pm-bullet-list>
  }
</div>
